import { render } from "./SchemeSetupComponent.vue?vue&type=template&id=49c19150&scoped=true"
import script from "./SchemeSetupComponent.vue?vue&type=script&lang=js"
export * from "./SchemeSetupComponent.vue?vue&type=script&lang=js"

import "./SchemeSetupComponent.vue?vue&type=style&index=0&id=49c19150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c19150"]])

export default __exports__